export default __webpack_public_path__ + "static/media/Rectangle 94.f024f172.png";